<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>{{ data?.title || 'Enter Text' }}</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content>
  <mat-form-field style="width: 100%;">
    <mat-label>{{ data?.prompt || 'Enter your text' }}</mat-label>
    <input matInput [(ngModel)]="inputText" (keyup.enter)="onOk()">
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onOk()" cdkFocusInitial>OK</button>
</mat-dialog-actions>
